function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var CreateNFTTemplate = require('./create-overlay.template');
var SaitoOverlay = require('./../../saito-overlay/saito-overlay');
var CreateNFT = /*#__PURE__*/function () {
  function CreateNFT(app, mod) {
    var _this = this;
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, CreateNFT);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(this.app, this.mod);
    this.help_overlay = new SaitoOverlay(this.app, this.mod);
    this.nft_type = null;
    this.module_provided_nfts = [];
    this.file = null;
    this.app.connection.on('saito-nft-create-render-request', function () {
      _this.image = null;
      _this.render();
    });
    this.enable_deposit = false;
  }
  return _createClass(CreateNFT, [{
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this2 = this;
        var _iterator, _step, nft_mod, obj, balance;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.reset();
              this.module_provided_nfts = [];
              this.overlay.show(CreateNFTTemplate(this.app, this.mod, this));
              _iterator = _createForOfIteratorHelper(this.app.modules.respondTo('saito-create-nft', this.mod));
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  nft_mod = _step.value;
                  obj = nft_mod.respondTo('saito-create-nft', this.mod);
                  this.module_provided_nfts.push(obj);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              _context.n = 1;
              return this.app.wallet.getBalance();
            case 1:
              balance = _context.v;
              if (Number(balance) == 0) {
                this.app.modules.renderInto('.get-saito-tokens');
              }
              setTimeout(function () {
                try {
                  for (var z = 0; z < _this2.module_provided_nfts.length; z++) {
                    var obj = _this2.module_provided_nfts[z];
                    if (obj.title) {
                      var x = "<option value=\"".concat(obj["class"], "\">").concat(obj.title, "</option>");
                      var y = document.querySelector('#create-nft-type-dropdown');
                      if (y) {
                        var opt = document.createElement('option');
                        opt.value = obj["class"];
                        opt.textContent = obj.title;
                        y.appendChild(opt);
                      }
                    }
                  }
                } catch (err) {
                  console.log('Error with Custom NFT Type: ' + JSON.stringify(err));
                }
                _this2.attachEvents();
              }, 0);
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "createObject",
    value: function () {
      var _createObject = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var obj, processed, z, modobj, _text, _text2, _text3, tmpobj, _text4, _text5, _t, _t2, _t3, _t4, _t5, _t6;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              obj = {};
              this.nft_type = document.querySelector('#create-nft-type-dropdown').value;
              processed = false;
              z = 0;
            case 1:
              if (!(z < this.module_provided_nfts.length)) {
                _context2.n = 8;
                break;
              }
              _context2.p = 2;
              modobj = this.module_provided_nfts[z];
              if (!modobj["class"].includes(this.nft_type)) {
                _context2.n = 5;
                break;
              }
              if (!modobj.createData) {
                _context2.n = 4;
                break;
              }
              _context2.n = 3;
              return modobj.createData(this.file);
            case 3:
              obj = _context2.v;
              processed = true;
              _context2.n = 5;
              break;
            case 4:
              obj.text = text;
              processed = true;
            case 5:
              _context2.n = 7;
              break;
            case 6:
              _context2.p = 6;
              _t = _context2.v;
              console.log('Error with Custom NFT Type: ' + JSON.stringify(_t));
            case 7:
              z++;
              _context2.n = 1;
              break;
            case 8:
              if (!(this.nft_type === 'text' && processed == false)) {
                _context2.n = 12;
                break;
              }
              _text = document.querySelector('#create-nft-textarea').value;
              _context2.p = 9;
              obj.text = _text;
              _context2.n = 11;
              break;
            case 10:
              _context2.p = 10;
              _t2 = _context2.v;
              salert('Provide parseable TEXT to create NFT');
              return _context2.a(2, false);
            case 11:
              processed = true;
            case 12:
              if (!(this.nft_type === 'token' && processed == false)) {
                _context2.n = 16;
                break;
              }
              _text2 = document.querySelector('#create-nft-textarea').value;
              _context2.p = 13;
              obj.ticker = _text2;
              _context2.n = 15;
              break;
            case 14:
              _context2.p = 14;
              _t3 = _context2.v;
              salert('Provide TOKEN name in TEXTAREA');
              return _context2.a(2, false);
            case 15:
              processed = true;
            case 16:
              if (!(this.nft_type === 'json' && processed == false)) {
                _context2.n = 20;
                break;
              }
              _text3 = document.querySelector('#create-nft-textarea').value;
              _context2.p = 17;
              tmpobj = JSON.parse(_text3);
              if (tmpobj.text) {
                obj = tmpobj.text;
              } else {
                obj = tmpobj;
              }
              _context2.n = 19;
              break;
            case 18:
              _context2.p = 18;
              _t4 = _context2.v;
              salert('Provide a valid JSON to create NFT');
              return _context2.a(2, false);
            case 19:
              processed = true;
            case 20:
              if (!(this.nft_type === 'css' && processed == false)) {
                _context2.n = 24;
                break;
              }
              _text4 = document.querySelector('#create-nft-textarea').value;
              _context2.p = 21;
              obj.css = _text4;
              _context2.n = 23;
              break;
            case 22:
              _context2.p = 22;
              _t5 = _context2.v;
              salert('Provide parseable TEXT to create NFT');
              return _context2.a(2, false);
            case 23:
              processed = true;
            case 24:
              if (!(this.nft_type === 'js' && processed == false)) {
                _context2.n = 28;
                break;
              }
              _text5 = document.querySelector('#create-nft-textarea').value;
              _context2.p = 25;
              obj.js = _text5;
              _context2.n = 27;
              break;
            case 26:
              _context2.p = 26;
              _t6 = _context2.v;
              salert('Provide parseable JS to create NFT');
              return _context2.a(2, false);
            case 27:
              processed = true;
            case 28:
              if (!(this.nft_type == 'image' && processed == false)) {
                _context2.n = 30;
                break;
              }
              if (this.image) {
                _context2.n = 29;
                break;
              }
              salert("Attach an image/file to create nft");
              return _context2.a(2, false);
            case 29:
              obj.image = this.image;
              processed = true;
            case 30:
              return _context2.a(2, obj);
          }
        }, _callee2, this, [[25, 26], [21, 22], [17, 18], [13, 14], [9, 10], [2, 6]]);
      }));
      function createObject() {
        return _createObject.apply(this, arguments);
      }
      return createObject;
    }()
  }, {
    key: "enableDepositInput",
    value: function enableDepositInput() {
      var amountInput = document.getElementById('create-nft-amount');
      var depositInput = document.getElementById('create-nft-deposit');
      if (!amountInput || !depositInput) return;

      //
      // Auto deposit (readonly, synced)
      //
      if (!this.enable_deposit) {
        // Make deposit uneditable
        depositInput.setAttribute('readonly', 'readonly');
        depositInput.style.border = 'none';
        depositInput.style.cursor = 'not-allowed';

        //
        // Attach sync listener
        //
        if (this._amountSyncListener) {
          amountInput.removeEventListener('input', this._amountSyncListener);
        }
        this._amountSyncListener = function () {
          var val = this.value.replace(/[^\d]/g, '');
          if (val.includes('.')) {
            val = val.split('.')[0];
          }
          this.value = val;
          depositInput.value = val || '0';
        };
        amountInput.addEventListener('input', this._amountSyncListener);

        // Force sync immediately
        depositInput.value = amountInput.value || '0';
      }
      //
      // Manual deposit
      //
      else {
        // Re-enable editing
        depositInput.removeAttribute('readonly');
        depositInput.style.border = '';
        depositInput.style.cursor = 'text';

        //
        // Remove sync listener
        //
        if (this._amountSyncListener) {
          amountInput.removeEventListener('input', this._amountSyncListener);
          this._amountSyncListener = null;
        }
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this3 = this;
      var this_self = this;
      this.enableDepositInput();
      if (document.querySelector('#create-nft-help-link')) {
        document.querySelector('#create-nft-help-link').onclick = function (e) {
          e.preventDefault();
          this_self.help_overlay.show("\n          <div class=\"create-nft-help-overlay\">\n            <div class=\"create-nft-help-text\">\n    SAITO NFTs can contain text or images or transactions. When you \n    transfer these NFTs to other members on the network, they get \n    access to the data contained within the transaction. When you \n    create an NFT, the first thing we ask is what data you want \n    inside it.\n    <p></p>\n    The cost of creating an NFT is a \"deposit\" of SAITO that \n    circulates with the NFT and ensures the network can track and\n    transfer it.\n                <p></p>\n                We recommend all NFTs are created with a 1 SAITO deposit. This \n    is not a network fee \u2014 the owner of the NFT can destroy the NFT\n    and recover the SAITO at any time.\n            </div>\n\n            <div class=\"create-nft-deposit-container\">\n              <input id=\"create-nft-enable-deposit\" type=\"checkbox\">\n              <span>let me manually specify the deposit</span>\n            </div>\n          </div>\n        ");
          var cbox = document.querySelector('#create-nft-enable-deposit');
          if (cbox) {
            cbox.checked = this_self.enable_deposit;
            cbox.onchange = function () {
              this_self.enable_deposit = cbox.checked;
              this_self.enableDepositInput();
            };
          }
        };
      }
      this.app.browser.addDragAndDropFileUploadToElement('nft-image-upload', /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(file) {
          var z, obj;
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.n) {
              case 0:
                z = 0;
              case 1:
                if (!(z < _this3.module_provided_nfts.length)) {
                  _context3.n = 3;
                  break;
                }
                obj = _this3.module_provided_nfts[z];
                if (!obj["class"]) {
                  _context3.n = 2;
                  break;
                }
                if (!obj["class"].includes(_this3.nft_type)) {
                  _context3.n = 2;
                  break;
                }
                _this3.file = file;
                return _context3.a(2);
              case 2:
                z++;
                _context3.n = 1;
                break;
              case 3:
                if (!_this3.image) {
                  _context3.n = 4;
                  break;
                }
                salert('NFT Image Editing not allowed, refresh to restart...');
                return _context3.a(2);
              case 4:
                _this3.image = file;
                _this3.addImage(file);
              case 5:
                return _context3.a(2);
            }
          }, _callee3);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }(), true);
      document.querySelector('#create-nft-type-dropdown').onchange = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(e) {
          var element, textarea, processed, z, obj;
          return _regenerator().w(function (_context4) {
            while (1) switch (_context4.n) {
              case 0:
                element = e.target;
                _this3.nft_type = element.value;
                textarea = document.querySelector('#create-nft-textarea');
                _this3.image = '';
                if (document.querySelector('.nft-file-transfer')) {
                  document.querySelector('.nft-file-transfer').remove();
                }
                if (document.querySelector('.nft-image-preview')) {
                  document.querySelector('.nft-image-preview').remove();
                }
                processed = false; //alert(this.nft_type + ' ... ');
                if (_this3.nft_type === 'text') {
                  document.querySelector('#nft-image-upload').style.display = 'none';
                  document.querySelector('#create-nft-textarea').style.display = 'flex';
                  textarea.innerHTML = 'provide text or markdown';
                }
                if (_this3.nft_type === 'token') {
                  document.querySelector('#nft-image-upload').style.display = 'none';
                  document.querySelector('#create-nft-textarea').style.display = 'flex';
                  textarea.innerHTML = 'provide token ticker';
                }
                if (_this3.nft_type === 'js') {
                  document.querySelector('#nft-image-upload').style.display = 'none';
                  document.querySelector('#create-nft-textarea').style.display = 'flex';
                  textarea.innerHTML = 'alert("Hello World!");';
                }
                if (_this3.nft_type === 'css') {
                  document.querySelector('#nft-image-upload').style.display = 'none';
                  document.querySelector('#create-nft-textarea').style.display = 'flex';
                  textarea.innerHTML = '--saito-primary: green;';
                }
                if (_this3.nft_type === 'json') {
                  document.querySelector('#nft-image-upload').style.display = 'none';
                  document.querySelector('#create-nft-textarea').style.display = 'flex';
                  textarea.innerHTML = JSON.stringify({
                    key1: 'value1',
                    key2: 'value2'
                  }, null, 2);
                }
                if (_this3.nft_type === 'image') {
                  document.querySelector('#nft-image-upload').style.display = 'flex';
                  document.querySelector('#create-nft-textarea').style.display = 'none';
                }
                if (_this3.nft_type === 'file') {
                  document.querySelector('#nft-image-upload').style.display = 'flex';
                  document.querySelector('#create-nft-textarea').style.display = 'none';
                }
                for (z = 0; z < _this3.module_provided_nfts.length; z++) {
                  obj = _this3.module_provided_nfts[z];
                  if (obj["class"]) {
                    if (obj["class"].includes(_this3.nft_type)) {
                      if (obj.json) {
                        document.querySelector('#nft-image-upload').style.display = 'none';
                        document.querySelector('#create-nft-textarea').style.display = 'block';
                        textarea.innerHTML = JSON.stringify(obj.json, null, 2);
                      }
                      if (obj.createData) {
                        document.querySelector('#nft-image-upload').style.display = 'flex';
                        document.querySelector('#create-nft-textarea').style.display = 'none';
                      }
                    }
                  }
                }
              case 1:
                return _context4.a(2);
            }
          }, _callee4);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }();
      if (document.getElementById('next-step')) {
        document.getElementById('next-step').onclick = function () {
          document.querySelector('.nft-creator-overlay.panels').classList.add('provide-metadata');
        };
      }
      if (document.getElementById('back-btn')) {
        document.getElementById('back-btn').onclick = function () {
          document.querySelector('.nft-creator-overlay.panels').classList.remove('provide-metadata');
        };
      }
      document.querySelector('#create_nft').onclick = /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(e) {
          var obj, numNFT, balance, depositAmt, fee, tx_msg, title_el, title, desc_field, description, publickey, newtx;
          return _regenerator().w(function (_context5) {
            while (1) switch (_context5.n) {
              case 0:
                _context5.n = 1;
                return _this3.createObject();
              case 1:
                obj = _context5.v;
                if (!(obj == false)) {
                  _context5.n = 2;
                  break;
                }
                return _context5.a(2);
              case 2:
                //
                // this value is not either nolan/saito
                // this represents the number of nft to mint
                //
                numNFT = parseInt(document.querySelector('#create-nft-amount').value);
                if (!(numNFT < 1)) {
                  _context5.n = 3;
                  break;
                }
                salert('Need to create at least one NFT');
                return _context5.a(2);
              case 3:
                if (!(numNFT > 100000000)) {
                  _context5.n = 4;
                  break;
                }
                salert('Cannot mint more than 100,000,000 NFTs');
                return _context5.a(2);
              case 4:
                _context5.n = 5;
                return _this3.app.wallet.getBalance();
              case 5:
                balance = _context5.v;
                // value of nft (nolan)
                depositAmt = parseInt(document.querySelector('#create-nft-deposit').value);
                depositAmt = BigInt(_this3.app.wallet.convertSaitoToNolan(depositAmt));
                if (!(balance < depositAmt)) {
                  _context5.n = 6;
                  break;
                }
                salert('Insufficient funds!');
                return _context5.a(2);
              case 6:
                if (!(depositAmt < BigInt(1))) {
                  _context5.n = 7;
                  break;
                }
                salert("Need at least 1 SAITO to create NFT");
                return _context5.a(2);
              case 7:
                fee = BigInt(0n);
                tx_msg = {
                  data: obj
                };
                title_el = document.querySelector('.saito-nft-metadata-box.title');
                title = title_el.value || title_el.getAttribute('placeholder') || '';
                title = title.trim();
                desc_field = document.querySelector('.saito-nft-metadata-box.description');
                description = (desc_field === null || desc_field === void 0 ? void 0 : desc_field.innerText) || (desc_field === null || desc_field === void 0 ? void 0 : desc_field.value) || desc_field.innerHTML || '';
                description = description.trim();
                if (title) {
                  tx_msg.title = title;
                }
                if (description) {
                  tx_msg.description = description;
                }
                console.log(title, description);
                _this3.overlay.close();
                if (obj.ticker) {
                  _this3.nft_type = 'NFT-' + obj.ticker;
                }
                siteMessage('Minting NFT...', 3000);
                _context5.n = 8;
                return _this3.app.wallet.getPublicKey();
              case 8:
                publickey = _context5.v;
                _context5.n = 9;
                return _this3.app.wallet.createMintNFTTransaction(BigInt(numNFT), depositAmt, tx_msg, fee, publickey, _this3.nft_type);
              case 9:
                newtx = _context5.v;
                _context5.n = 10;
                return newtx.sign();
              case 10:
                _context5.n = 11;
                return _this3.app.network.propagateTransaction(newtx);
              case 11:
                return _context5.a(2);
            }
          }, _callee5);
        }));
        return function (_x3) {
          return _ref3.apply(this, arguments);
        };
      }();
    }
  }, {
    key: "addImage",
    value: function addImage() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var fileInfo = this.parseFileInfo(data);
      var html = "";
      if (fileInfo.isImage) {
        html = "<div class=\"nft-image-preview\">\n                      <img style=\"max-height: inherit; max-width: inherit; height: inherit; width: inherit\" src=\"".concat(data, "\"/>\n              </div>");
      } else {
        html = "\n                <div class=\"nft-file-transfer\">\n                    <div class=\"file-transfer-progress\"></div>\n                    <i class=\"fa-solid fa-file-export\"></i>\n                    <div class=\"file-name\">".concat(fileInfo.name, "</div>\n                    <div class=\"file-size fixed-width\">").concat(fileInfo.size / 1024, " KB</div>\n                </div>\n            ");
      }
      this.app.browser.addElementToSelector(html, '.create-nft-container .nft-creator .textarea-container');
      document.querySelector('#nft-image-upload').style.display = 'none';
    }

    // Utilities for processing a file...
  }, {
    key: "parseDataUri",
    value: function parseDataUri(dataUri) {
      var _dataUri$split = dataUri.split(',', 2),
        _dataUri$split2 = _slicedToArray(_dataUri$split, 2),
        header = _dataUri$split2[0],
        data = _dataUri$split2[1];
      if (!header.startsWith('data:')) {
        throw new Error('Not a valid data URI');
      }
      // strip leading "data:"
      var parts = header.slice(5).split(';');
      var mediaType = parts[0] || '';
      var params = {};
      for (var i = 1; i < parts.length; i++) {
        var _parts$i$split = parts[i].split('='),
          _parts$i$split2 = _slicedToArray(_parts$i$split, 2),
          key = _parts$i$split2[0],
          val = _parts$i$split2[1];
        // treat bare "base64" as a boolean flag
        params[key] = val === undefined ? '' : val;
      }
      return {
        mediaType: mediaType,
        params: params,
        data: data
      };
    }
  }, {
    key: "extractMediaType",
    value: function extractMediaType(dataUri) {
      try {
        return this.parseDataUri(dataUri).mediaType || null;
      } catch (_unused) {
        return null;
      }
    }
  }, {
    key: "extractExtension",
    value: function extractExtension(dataUri) {
      var mediaType = this.extractMediaType(dataUri);
      if (!mediaType) return null;
      var parts = mediaType.split('/');
      if (parts.length !== 2) return null;
      // drop any "+suffix" (e.g. "svg+xml" → "svg")
      return parts[1].split('+')[0].toLowerCase();
    }
  }, {
    key: "extractFileName",
    value: function extractFileName(dataUri) {
      try {
        var _this$parseDataUri = this.parseDataUri(dataUri),
          params = _this$parseDataUri.params;
        // look for either "name" or "filename"
        var fname = params.name || params.filename;
        if (fname) return fname;
        var ext = this.extractExtension(dataUri) || 'bin';
        return "file.".concat(ext);
      } catch (_unused2) {
        return null;
      }
    }
  }, {
    key: "getFileSizeFromDataUri",
    value: function getFileSizeFromDataUri(dataUri) {
      try {
        var base64 = this.parseDataUri(dataUri).data;
        // count padding characters ("=" at end)
        var paddingMatches = base64.match(/=+$/);
        var padding = paddingMatches ? paddingMatches[0].length : 0;
        // formula: bytes = 3/4 * length_of_base64 - padding
        return Math.round(base64.length * 3 / 4 - padding);
      } catch (_unused3) {
        return null;
      }
    }
  }, {
    key: "isImageDataUri",
    value: function isImageDataUri(dataUri) {
      var mt = this.extractMediaType(dataUri);
      return mt !== null && mt.startsWith('image/');
    }
  }, {
    key: "parseFileInfo",
    value: function parseFileInfo(dataUri) {
      return {
        mediaType: this.extractMediaType(dataUri),
        extension: this.extractExtension(dataUri),
        name: this.extractFileName(dataUri),
        size: this.getFileSizeFromDataUri(dataUri),
        isImage: this.isImageDataUri(dataUri)
      };
    }
  }, {
    key: "reset",
    value: function reset() {
      this.image = '';
      this.nft_type = null;
      this.module_provided_nfts = [];
      this.file = null;
    }
  }]);
}();
module.exports = CreateNFT;